import { Component } from '@angular/core';
import { TabComponent } from '../../../components/tab/tab.component';
import { APITableComponent } from "../../../components/table/api-table/api-table.component";
import { TabLayoutComponent } from "../../../components/tab-layout/tab-layout.component";

@Component({
  selector: 'app-countries-tab',
  imports: [APITableComponent, TabLayoutComponent],
  templateUrl: './countries-tab.component.html',
  styleUrl: './countries-tab.component.scss',
  providers: [{ provide: TabComponent, useExisting: CountriesTabComponent }],
})
export class CountriesTabComponent extends TabComponent {
  override name = this.dictionaryService.get('Countries');

  public async main(): Promise<void> {}
}
